import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import { useCreateDossierId, useGetDossier } from 'src/networking/terminals'
import {
  usePostPisPaymentCallback,
  usePutPisUpdateState,
} from 'src/networking/terminals/pis/pis.gates'
import {
  atomDossier,
  atomPaymentData,
  atomPisPaymentId,
  atomPolicy,
  atomSelectedProduct,
  selectorDossierInsured,
} from 'src/storage'
import { Insured } from 'src/types'
import { mapDossier } from 'src/utils'

export const usePaymentSuccess = () => {
  const { t } = useTranslation()

  const resetDossier = useResetRecoilState(atomDossier)
  const resetPolicy = useResetRecoilState(atomPolicy)
  const resetSelectedProduct = useResetRecoilState(atomSelectedProduct)
  const insured = useRecoilValue(selectorDossierInsured)
  const saveDossier = useSetRecoilState(atomDossier)
  const setPaymentData = useSetRecoilState(atomPaymentData)
  const [pisPaymentId, setPisPaymentId] = useRecoilState(atomPisPaymentId)

  const { crossGate: getDossier } = useGetDossier()
  const { crossGate: createDossierId } = useCreateDossierId()

  const { crossGate: postPisPaymentCallback } = usePostPisPaymentCallback()
  const { crossGate: putPisUpdateState } = usePutPisUpdateState()

  useEffect(() => {
    setPaymentData(undefined)
    resetPolicy()
    resetSelectedProduct()
    console.log('.................insured', insured, pisPaymentId)
    if (
      !insured ||
      (insured && (!insured.idAssicurato || !insured.codiceAssociato || !insured.utenteOggettoId))
    ) {
      return
    }
    if (pisPaymentId) {
      postPisPaymentCallback(
        {
          body: {
            transactionId: pisPaymentId,
          },
        },
        {
          onSuccess: (response) => {
            setPisPaymentId(undefined)
            if (response) {
              putPisUpdateState(
                {
                  uriParams: {
                    shopId: response.numPoli,
                  },
                },
                {
                  onSuccess: () => {
                    createDossier(insured)
                  },
                }
              )
            }
          },
          onFailure: () => {
            setPisPaymentId(undefined)
          },
        }
      )
    } else {
      createDossier(insured)
    }
  }, [])

  const createDossier = (insured: Insured) => {
    createDossierId(
      {
        body: {
          codiceAssociato: insured.codiceAssociato,
          associatoId: insured.idAssicurato,
          utenteOggettoId: insured.utenteOggettoId,
          productCode: null,
        },
      },
      {
        onSuccess: (newDossier) => {
          console.log('...............new dossier', newDossier)
          resetDossier()
          getDossier(
            {
              headers: {
                xDossierId: newDossier.xdossierId,
              },
            },
            {
              onSuccess: (newDossierCreated) => {
                const dossier = mapDossier(newDossierCreated)
                saveDossier(dossier)
              },
            }
          )
        },
      }
    )
  }

  return {
    t,
  }
}
